// extracted by mini-css-extract-plugin
module.exports = {"registerBtn":"__registerBtn___pGAa","formField":"__formField__svlfB"};